import { motion } from "motion/react";
import { Helmet } from "react-helmet-async";

export function PrivacyPolicy() {
  return (
    <div className="pt-24 pb-16 min-h-screen">
      <Helmet>
        <title>Privacy Policy | Iwantcoaching</title>
        <meta name="description" content="Our privacy policy outlines how we handle your personal information at Iwantcoaching." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://iwantcoaching.co.za/privacy-policy" />
      </Helmet>
      <section className="py-16 bg-muted/30">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto text-center"
          >
            <h1 className="text-5xl md:text-7xl font-serif mb-6">Privacy Policy</h1>
            <p className="text-xl text-muted-foreground leading-relaxed">
              Your privacy is important to us. This policy outlines how we handle your personal information.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-6 max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="prose prose-stone lg:prose-lg mx-auto text-muted-foreground"
          >
            <h2 className="text-2xl font-serif text-primary mb-4">1. Information We Collect</h2>
            <p className="mb-8">
              We collect information you provide directly to us, such as when you book a session, sign up for our newsletter, or contact us with an inquiry. This may include your name, email address, phone number, and any other information you choose to provide.
            </p>

            <h2 className="text-2xl font-serif text-primary mb-4">2. How We Use Your Information</h2>
            <p className="mb-8">
              We use the information we collect to provide, maintain, and improve our services, to communicate with you, and to personalize your experience with Iwantcoaching.
            </p>

            <h2 className="text-2xl font-serif text-primary mb-4">3. Information Sharing</h2>
            <p className="mb-8">
              We do not share your personal information with third parties except as described in this policy or with your consent. We may share information with service providers who perform services on our behalf.
            </p>

            <h2 className="text-2xl font-serif text-primary mb-4">4. Data Security</h2>
            <p className="mb-8">
              We take reasonable measures to help protect information about you from loss, theft, misuse, and unauthorized access, disclosure, alteration, and destruction.
            </p>

            <h2 className="text-2xl font-serif text-primary mb-4">5. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at <a href="mailto:johan@iwantcoaching.co.za" className="text-primary hover:underline">johan@iwantcoaching.co.za</a>.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
